const ProfileIcon = ({ height = "20" }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8389 1.70703C8.68804 1.70703 6.93945 3.45562 6.93945 5.60646C6.93945 7.71625 8.58953 9.42379 10.7404 9.49767C10.806 9.48946 10.8717 9.48946 10.921 9.49767C10.9374 9.49767 10.9456 9.49767 10.962 9.49767C10.9702 9.49767 10.9702 9.49767 10.9784 9.49767C13.08 9.42379 14.7301 7.71625 14.7383 5.60646C14.7383 3.45562 12.9897 1.70703 10.8389 1.70703Z"
        fill="#7E858F"
      />
      <path
        d="M15.0102 11.6891C12.7198 10.1622 8.9846 10.1622 6.67778 11.6891C5.6352 12.3787 5.06055 13.3228 5.06055 14.3325C5.06055 15.3423 5.6352 16.2782 6.66957 16.9677C7.81888 17.7394 9.32939 18.1252 10.8399 18.1252C12.3504 18.1252 13.8609 17.7394 15.0102 16.9677C16.0446 16.2699 16.6193 15.3341 16.6193 14.3161C16.6111 13.3146 16.0446 12.3705 15.0102 11.6891ZM12.7527 13.6594L10.6839 15.7281C10.5854 15.8266 10.4541 15.8759 10.3227 15.8759C10.1914 15.8759 10.06 15.8184 9.96151 15.7281L8.92713 14.6938C8.73011 14.4967 8.73011 14.1684 8.92713 13.9713C9.12416 13.7743 9.45253 13.7743 9.64955 13.9713L10.3227 14.6445L12.0303 12.937C12.2273 12.7399 12.5557 12.7399 12.7527 12.937C12.9579 13.134 12.9579 13.4624 12.7527 13.6594Z"
        fill="#7E858F"
      />
    </svg>
  );
};

export default ProfileIcon;
